import _ from "underscore";
import vars from "@exovera/narrative-tracker-variables";
import { convertMapCodeToEntityFilter } from "lib/helpers/filterHelpers.js";
import { addOrRemove } from "@exovera/helpers";

import { 
	TOGGLE_TRANSLATE_ENTITIES_COMPARE,
	RECEIVE_ENTITIES,
	RECEIVE_ENTITIES_ERROR,
	RECEIVE_MAP_DATA,
 } from "actions/constants";

import { updateDataCompare, updateDataMoe, updateArticleDataCompare, updateEntityDataCompare } from "actions/dataCompare.js";

import { mergeEntityFilters, pluckActiveFilters } from "@exovera/helpers";
import { fetchCompareArticles, fetchTimeseriesCompare } from "actions/fetch";
import {
	addConfigFilters,
	isolateStateFilter,
	parseActiveFilters,
	parseEntityFilters,
	reactivateFilters,
	removeLocationFilters,
	toggleEntities,
} from "lib/helpers/filterHelpers.js";
import { makeFetchKey } from "lib/helpers/helpers.js";

// Clear changes
export function clearProposedChangesLeft() {
	return {
		type: "clearProposedChangesLeft",
	};
}
export function clearProposedChangesRight() {
	return (dispatch, getState) => {
		const { location } = getState().router;
		dispatch({
			type: "clearProposedChangesRight",
			eventsTab: location && location.pathname === "/events",
			eventFilters: getState().events.eventFilters,
		});
	};
}
// Clears all filters while maintaining the narrative
// Doesn't involve the config
export function clearFiltersLeft() {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { location } = getState().router;
		const { highlightable } = getState().base;
		const { perspective, mapHighlightId } = getState().leftCompare;
		const { eventTypes, featuredEventId } = getState().events;
		const narrative = getState().leftCompare.activeNarrativeData;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const activeMapHighlight = _.find(highlightable, (object) => {
			return object.geoState === mapHighlightId;
		});
		const narType = moeMode ? "leftMOE" : "left";
		const { contentFilteredByDate, currentZoom } = varStore[narType][perspective]; // current nar

		dispatch({ type: "mainSpinnerOnLeft" });
		dispatch({ type: "clearKeywordsLeft" });

		// Get correlation if in events mode
		if (eventMode) {
			dispatch(
				fetchEventCorrelationInit({
					primary: narrative,
					secondary: _.find(eventTypes, (event) => {
						return event.id === featuredEventId;
					}),
					// Include all events in group - the right side is not updating.
					eventsToFetch: eventTypes,
					activeFilters: [],
				})
			);
		}

		if (narrative.parent === "MOE" || narrative.parent === "moe") {
			dispatch(
				updateDataMoe({
					side: "Left",
					narrative,
					perspective,
					currentZoom,
					activeFilters: [],
					entityFilters: [],
					keywords: [],
					mapHighlightId: false,
					contentFilteredByDate,
				})
			);
		} else {
			dispatch(
				updateDataCompare({
					side: "Left",
					narrative,
					perspective,
					currentZoom,
					activeFilters: [],
					entityFilters: [],
					keywords: [],
					mapHighlightId: activeMapHighlight && activeMapHighlight.geoState,
					contentFilteredByDate,
					eventMode,
				})
			);
		}
	};
}
export function clearFiltersRight() {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { highlightable } = getState().base;
		const { location } = getState().router;
		const { perspective, mapHighlightId } = getState().rightCompare;
		const { eventTypes } = getState().events;
		const narrative = getState().rightCompare.activeNarrativeData;
		const leftActiveNarrativeData = getState().leftCompare.activeNarrativeData;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const activeMapHighlight = _.find(highlightable, (object) => {
			return object.geoState === mapHighlightId;
		});
		const narType = moeMode ? "rightMOE" : "right";
		const { contentFilteredByDate, currentZoom } = varStore[narType][perspective]; // current nar

		dispatch({ type: "mainSpinnerOnRight" });
		dispatch({ type: "clearKeywordsRight" });

		// Get correlation if in events mode
		if (eventMode) {
			dispatch(
				fetchEventCorrelationInit({
					primary: leftActiveNarrativeData,
					secondary: narrative,
					// Include the rest of the events
					eventsToFetch: _.reject(eventTypes, (event) => {
						return event.id === narrative.id;
					}),
					activeFilters: [],
					primaryNotFetching: true,
				})
			);
		}

		if (narrative.parent === "MOE" || narrative.parent === "moe") {
			dispatch(
				updateDataMoe({
					side: "Right",
					narrative,
					perspective,
					currentZoom,
					activeFilters: [],
					entityFilters: [],
					keywords: [],
					mapHighlightId: false,
					contentFilteredByDate,
				})
			);
		} else {
			dispatch(
				updateDataCompare({
					side: "Right",
					narrative,
					perspective,
					currentZoom,
					activeFilters: [],
					entityFilters: [],
					keywords: [],
					mapHighlightId: activeMapHighlight && activeMapHighlight.geoState,
					contentFilteredByDate,
					eventMode,
				})
			);
		}
	};
}

export function filterByEntityLeft(entity) {
	return (dispatch) => {
		dispatch(filterByEntityCompare(entity, "Left"));
	};
}
export function filterByEntityRight(entity) {
	return (dispatch) => {
		dispatch(filterByEntityCompare(entity, "Right"));
	};
}
// Toggles clicked entity from currentFiltersList and refetches the data
export function filterByEntityCompare(entity, side) {
	// console.log("filterByEntityCompare", entity);
	return (dispatch, getState) => {
		const {
			activeNarrativeData,
			activeKeywords,
			contentFilteredByDate,
			currentZoom,
			filtersList,
			entities,
			entityTypeOptions,
			mapHighlightId,
			perspective,
		} = side === "Left" ? getState().leftCompare : getState().rightCompare;
		const { location } = getState().router;
		const { eventTypes, featuredEventId } = getState().events;

		const eventMode = location && location.pathname === "/events";
		dispatch({ type: `beginFilteringByEntity${side}` }); // Set spinners
		const toggledEntities = toggleEntities(entities, entityTypeOptions, entity);

		// Get correlation if in events mode
		// There aren't entities for events, so this is only if the left is updating
		if (eventMode && side === "Left") {
			dispatch(
				fetchEventCorrelationInit({
					primary: activeNarrativeData,
					secondary: _.find(eventTypes, (event) => {
						return event.id === featuredEventId;
					}),
					// Include all events in group - the right side is not updating.
					eventsToFetch: eventTypes,
					activeFilters: filtersList,
				})
			);
		}

		dispatch(
			updateDataCompare({
				side,
				narrative: activeNarrativeData,
				perspective,
				currentZoom,
				activeFilters: filtersList,
				// Passes only active entities
				entityFilters: parseEntityFilters(toggledEntities, entityTypeOptions, false),
				keywords: activeKeywords,
				mapHighlightId,
				contentFilteredByDate,
				eventMode,
			})
		);
	};
}

export function linkButtonClick(mapPosition, mapPlaying) {
	return {
		type: "linkButtonClick",
		mapPosition,
		mapPlaying,
	};
}
export function graphLinkButtonClick() {
	return (dispatch, getState) => {
		const leftMaxY = getState().leftCompare.maxYValue;
		const rightMaxY = getState().rightCompare.maxYValue;
		const commonMaxY = leftMaxY > rightMaxY ? leftMaxY : rightMaxY;
		dispatch({
			type: "graphLinkButtonClick",
			commonMaxY,
		});
	};
}
export const updateMaxYLeft = (maxYValue) => {
	return {
		type: "updateMaxYLeft",
		maxYValue,
	};
};
export const updateMaxYRight = (maxYValue) => {
	return {
		type: "updateMaxYRight",
		maxYValue,
	};
};

export const correlationLabelClick = (data, filters) => {
	return (dispatch, getState) => {
		const { eventTypes } = getState().events;
		const event = _.find(eventTypes, (e) => {
			return e.id === data.id;
		});
		dispatch(fetchComparisonRight(event, filters));
	};
};

// fetch new data
//  this dispatches all of the reqeuests for the left side
// 		Used when the narrative and/or filter changes are submitted. Not when the tab is opened
export function fetchComparisonLeft(params) {
	const { narrative, currentFilters } = params;
	// console.log("fetchComparisonLeft", narrative);
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { highlightable } = getState().base;
		const { location } = getState().router;
		const { projectMapConfig } = getState().projectConfig;
		const { perspective, entities, entityTypeOptions, mapHighlightId, visibleKeywords } = getState().leftCompare;
		const previousNarrative = getState().leftCompare.activeNarrativeData;
		const { eventTypes, featuredEventId } = getState().events;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const tabSlug = location && location.pathname ? location.pathname.replace(/^\//, "") : "";
		const narrativeIsChanging = !previousNarrative || narrative.id !== previousNarrative.id;

		// Only use the config if the narrative is changing - otherwise, allow changes
		const configStateFilter = narrativeIsChanging && projectMapConfig && projectMapConfig[tabSlug] && projectMapConfig[tabSlug].state;
		const activeMapHighlight = _.find(highlightable, (object) => {
			return object.geoState === mapHighlightId;
		});
		const narType = moeMode ? "leftMOE" : "left";
		const { contentFilteredByDate, currentZoom } = varStore[narType][perspective]; // current nar
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// NOTE: This will have to be rewritten if entities ever exist in Reaction mode
		const entityFilters = perspective === "Source" ? parseEntityFilters(entities, entityTypeOptions, true) : [];

		dispatch({ type: "mainSpinnerOnLeft" });
		dispatch({ type: "convertKeywordsToActiveLeft" });

		const activeFilters = addConfigFilters(parseActiveFilters(currentFilters), configStateFilter, baseFilters);
		// console.log("activeFilters", activeFilters);

		// Get correlation if in events mode
		if (eventMode) {
			dispatch(
				fetchEventCorrelationInit({
					primary: narrative,
					secondary: _.find(eventTypes, (event) => {
						return event.id === featuredEventId;
					}),
					// Include all events in group - the right side is not updating.
					eventsToFetch: eventTypes,
					activeFilters,
				})
			);
		}

		if (moeMode && (narrative.parent === "MOE" || narrative.parent === "moe")) {
			dispatch(
				updateDataMoe({
					side: "Left",
					narrative,
					perspective,
					currentZoom, // keep old zoom
					activeFilters,
					entityFilters,
					keywords: visibleKeywords,
					mapHighlightId: false,
					contentFilteredByDate: !narrativeIsChanging && contentFilteredByDate,
				})
			);
		} else {
			dispatch(
				updateDataCompare({
					side: "Left",
					activeFilters: addConfigFilters(parseActiveFilters(currentFilters), configStateFilter, baseFilters),
					currentZoom,
					contentFilteredByDate: !narrativeIsChanging && contentFilteredByDate,
					entityFilters,
					keywords: visibleKeywords,
					eventMode,
					narrative,
					perspective,
					mapHighlightId: (configStateFilter && configStateFilter.geoState) || (activeMapHighlight && activeMapHighlight.geoState),
				})
			);
		}

		dispatch({ type: "clearMapHighlightLeft" });
		dispatch({ type: "highlightCountyOffLeft" });
		dispatch({ type: "unlockGraph" });
		// Highlight map if the project calls for it
		if (configStateFilter) {
			dispatch({
				type: "highlightMapLeft",
				data: configStateFilter,
				color: narrative.color.dark,
				currentZoom,
			});
		} else if (activeMapHighlight) {
			dispatch({
				type: "highlightMapLeft",
				data: activeMapHighlight,
				color: narrative.color.dark,
				currentZoom,
			});
		}
		// Clear contentFilteredByDate
		if (narrativeIsChanging) {
			dispatch({ type: "clearIndicatorLeft" });
		}
	};
}
export function fetchComparisonRight(params) {
	const { narrative, currentFilters } = params;
	// console.log("fetchComparisonRight", narrative, currentFilters);
	// Add a default color if the narrative doesn't have one
	if (!narrative.color) {
		narrative.color = {
			name: "Sky",
			dark: "#accaf2",
			light: "#542792",
		};
	}

	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { highlightable } = getState().base;
		const { location } = getState().router;
		const { projectMapConfig } = getState().projectConfig;
		const { perspective, entities, entityTypeOptions, mapHighlightId, visibleKeywords } = getState().rightCompare;
		const previousNarrative = getState().rightCompare.activeNarrativeData;
		const { eventTypes, featuredEventId } = getState().events;
		const leftActiveNarrativeData = getState().leftCompare.activeNarrativeData;

		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";
		const tabSlug = location && location.pathname ? location.pathname.replace(/^\//, "") : "";
		const narrativeIsChanging = !previousNarrative || narrative.id !== previousNarrative.id;

		// Only use the config if the narrative is changing - otherwise, allow changes
		const configStateFilter = narrativeIsChanging && projectMapConfig && projectMapConfig[tabSlug] && projectMapConfig[tabSlug].state;
		const activeMapHighlight = _.find(highlightable, (object) => {
			return object.geoState === mapHighlightId;
		});
		const narType = moeMode ? "rightMOE" : "right";
		const { contentFilteredByDate, currentZoom } = varStore[narType][perspective]; // current nar
		const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
		// NOTE: This will have to be rewritten if entities ever exist in Reaction mode
		const entityFilters = perspective === "Source" ? parseEntityFilters(entities, entityTypeOptions, true) : [];
		const activeFilters = addConfigFilters(parseActiveFilters(currentFilters), configStateFilter, baseFilters);

		dispatch({ type: "mainSpinnerOnRight" });
		dispatch({ type: "convertKeywordsToActiveRight" });

		// Get correlation if in events mode
		// NOTE: sometimes this won't be necessary (if the filters havent' changed)
		if (eventMode) {
			dispatch(
				fetchEventCorrelationInit({
					primary: leftActiveNarrativeData,
					secondary: narrative,
					// Include the rest of the events
					eventsToFetch: _.reject(eventTypes, (event) => {
						return event.id === narrative.id;
					}),
					activeFilters,
					primaryNotFetching: true,
				})
			);
		}

		if (narrative.parent === "MOE" || narrative.parent === "moe") {
			dispatch(
				updateDataMoe({
					side: "Right",
					narrative,
					perspective,
					currentZoom, // keep old zoom
					activeFilters: addConfigFilters(parseActiveFilters(currentFilters), configStateFilter, baseFilters),
					entityFilters,
					keywords: visibleKeywords,
					mapHighlightId: false,
					contentFilteredByDate: !narrativeIsChanging && contentFilteredByDate,
				})
			);
		} else {
			dispatch(
				updateDataCompare({
					side: "Right",
					activeFilters,
					contentFilteredByDate: !narrativeIsChanging && contentFilteredByDate,
					currentZoom,
					entityFilters,
					keywords: visibleKeywords,
					eventMode,
					mapHighlightId: (configStateFilter && configStateFilter.geoState) || (activeMapHighlight && activeMapHighlight.geoState),
					narrative,
					perspective,
				})
			);
		}

		dispatch({ type: "clearMapHighlightRight" });
		dispatch({ type: "highlightCountyOffRight" });
		dispatch({ type: "unlockGraph" });
		// Highlight map if the project calls for it
		if (configStateFilter) {
			dispatch({
				type: "highlightMapRight",
				data: configStateFilter,
				color: narrative.color ? narrative.color.dark : "#accaf2",
				currentZoom,
			});
		} else if (activeMapHighlight) {
			dispatch({
				type: "highlightMapRight",
				data: activeMapHighlight,
				color: narrative.color ? narrative.color.dark : "#accaf2",
				currentZoom,
			});
		}
		// Clear contentFilteredByDate
		if (narrativeIsChanging) {
			dispatch({ type: "clearIndicatorRight" });
		}
	};
}

// Removes ALL location filters and refetches the content
export function clearLocationFiltersLeft() {
	return (dispatch, getState) => {
		const { activeNarrativeData, perspective, filtersList } = getState().leftCompare;

		const updatedFiltersList = removeLocationFilters(filtersList);
		const cleanFilters = perspective === "Source" ? getState().leftCompare.sourceFiltersClean : getState().leftCompare.audienceFiltersClean;
		const currentFilters = reactivateFilters(cleanFilters, updatedFiltersList);
		fetchComparisonLeft(activeNarrativeData, currentFilters);
	};
}
export function clearLocationFiltersRight() {
	return (dispatch, getState) => {
		const { activeNarrativeData, perspective, filtersList } = getState().rightCompare;

		const updatedFiltersList = removeLocationFilters(filtersList);
		const cleanFilters =
			perspective === "Source" ? getState().rightCompare.sourceFiltersClean : getState().rightCompare.audienceFiltersClean;
		const currentFilters = reactivateFilters(cleanFilters, updatedFiltersList);
		fetchComparisonRight(activeNarrativeData, currentFilters);
	};
}

export function requestMap(side) {
	return {
		type: `requestMap${side}`,
	};
}
export function requestArticles(side) {
	return {
		type: `requestArticles${side}`,
	};
}
export function requestEntities(side) {
	return {
		type: `requestEntities${side}`,
	};
}

export function toggleTranslateEntitiesCompare() {
	return (dispatch, getState) => {
		const { translateEntitiesCompare } = getState().leftCompare;
		dispatch({
			type: TOGGLE_TRANSLATE_ENTITIES_COMPARE,
			translateEntitiesCompare: !translateEntitiesCompare,
		});
		dispatch(updateEntityDataCompare({ translateEntities: !translateEntitiesCompare, side: "Left" }));
		dispatch(updateEntityDataCompare({ translateEntities: !translateEntitiesCompare, side: "Right" }));
	};
}

export function receiveMapDataCompare(params) {
	const { currentFilters, currentMapSegmentSpan, data, fetchKey, filtersList, narrative, notMOE, perspective, side, stateCode } = params;
	// console.log(
	// 	"<----- receiveMapDataCompare",
	// 	data,
	// 	narrative,
	// 	perspective,
	// 	filtersList,
	// 	currentFilters,
	// 	side,
	// 	stateCode,
	// 	notMOE,
	// 	fetchKey
	// );
	return (dispatch, getState) => {
		const { projectTheme, darkUI } = getState().projectConfig;
		const { activeNarrativeData, currentZoom, mapHighlightId, mapPlaying, mapPosition } =
			side === "Left" ? getState().leftCompare : getState().rightCompare;

		// mapHighlight needs to be set if we've navigated from the narratives tab (instead of clicking the map)
		if (mapHighlightId && stateCode && mapHighlightId !== stateCode) {
			console.log("mapHighlightId", mapHighlightId, "stateCode", stateCode);
			const mapDataByPosition = mapPlaying && mapPosition ? data.dataInterval[mapPosition] : data.dataTotal;
			const highlightData =
				mapDataByPosition &&
				_.find(mapDataByPosition.location, (location) => {
					return location.geoState === stateCode;
				});

			dispatch({
				type: `highlightMap${side}`,
				data: highlightData,
				color: activeNarrativeData ? activeNarrativeData.color : { dark: "#accaf2", light: "#7c8faf" },
				currentZoom,
			});
		}

		dispatch({
			type: `${RECEIVE_MAP_DATA}_${side}`,
			data,
			narrative,
			perspective,
			filtersList,
			currentFilters,
			currentMapSegmentSpan,
			isMOE: !notMOE,
			fetchKey,
			filterColor: projectTheme ? projectTheme.accent : darkUI ? vars.cerulean_1 : vars.cerulean_2,
		});
	};
}

// receive timeseries
export function receiveTimeseriesCompare(parameters) {
	const { data, dataType, narrative, perspective, filtersList, currentFilters, side, fetchKey, parent } = parameters;
	// console.log("<---- receiveTimeseriesCompare", {
	// 	data,
	// 	dataType,
	// 	side,
	// });

	return (dispatch, getState) => {
		const { aiOnly, aiSupport } = getState().commonUI;
		const { percentageTypes, projectMapConfig } = getState().projectConfig;
		const { location } = getState().router;

		const eventMode = location && location.pathname === "/events";

		dispatch({
			type: `receiveCompareTimeseries${side}`,
			aiOnly,
			aiSupport,
			data,
			dataType,
			narrative,
			perspective,
			filtersList,
			currentFilters,
			fetchKey,
			parent,
			eventMode,
			eventFilters: getState().events.eventFilters,
			percentageTypes,
			projectMapConfig,
		});
	};
}

export const updateCompareContentByHeaderLeft = (header, pageLength, offset) => {
	return (dispatch) => {
		dispatch(
			updateCompareContentByHeader({
				header,
				side: "Left",
				pageLength,
				offset
			})
		);
	};
};
export const updateCompareContentByHeaderRight = (header, pageLength, offset) => {
	return (dispatch) => {
		dispatch(
			updateCompareContentByHeader({
				header,
				side: "Right",
				pageLength,
				offset
			})
		);
	};
};

export const updateCompareContentByHeader = (params) => {
	const { header, side, pageLength, offset } = params;
	const getDefaultSortAscending = () => {
		switch (header.id) {
			case "date":
			case "fdate":
			case "shares":
			case "dupCount":
				return false;
			default:
				return true;
		}
	}
	return (dispatch, getState) => {
		if (!side) {
			console.error("updateCompareContentByHeader requires 'side'");
		}
		dispatch({ type: `requestArticles${side}` });
		const {
			activeKeywords,
			activeNarrativeData,
			activeRelevancy,
			contentFilteredByDate,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			currentZoom,
			entityFilters,
			filtersList,
			perspective,
			showDuplicates,
		} = side === "Left" ? getState().leftCompare : getState().rightCompare;

		const activeFilters = pluckActiveFilters(filtersList);
		const mergedFilters = mergeEntityFilters({
			activeFilters,
			entityFilters,
			keywords: activeKeywords,
			perspective,
		});
		const startDate = contentFilteredByDate ? Number(contentFilteredByDate.begin) : currentZoom.begin;
		const endDate = contentFilteredByDate
			? contentFilteredByDate.begin // fetch functions add a day automatically
			: currentZoom.end;

		// Set the sort variables by perspective
		const contentHeaderSortType = perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending = perspective === "Source" ? contentHeaderSortAscendingSource : contentHeaderSortAscendingAudience;

		const ascending = !header 
			? contentHeaderSortAscending 
			: (header.id === contentHeaderSortType) 
				? !contentHeaderSortAscending 
				: getDefaultSortAscending();

		const fetchKey = makeFetchKey(activeNarrativeData, perspective, activeFilters, currentZoom);
		dispatch({ type: `mostRecentFetch${side}`, fetchKey });

		dispatch(
			fetchCompareArticles({
				ascending,
				currentFilters: mergedFilters || [],
				endDate,
				fetchKey,
				filtersList,
				narrative: activeNarrativeData,
				perspective,
				relevancy: activeRelevancy,
				showDuplicates,
				side,
				sortBy: header ? header.id : contentHeaderSortType,
				startDate,
				pageLength,
				offset,
			})
		);
		if (header) {
			dispatch({
				type: `setContentSort${side}`,
				sortBy: header.id,
				ascending,
				perspective,
			});
		}
	};
};

// receive articles
export function receiveCompareArticles(parameters) {
	const { articles, narrative, perspective, filtersList, currentFilters, side, fetchKey } = parameters;
	return (dispatch, getState) => {
		const { projectSpecificTagFormat } = getState().projectConfig;
		const { distractionFreeDeveloperMode } = getState().commonUI;
		dispatch({
			type: `receiveArticles${side}`,
			articles,
			narrative,
			perspective,
			filtersList,
			currentFilters,
			fetchKey,
			projectSpecificTagFormat,
			distractionFreeDeveloperMode,
		});
	};
}

// receive entities
export function receiveCompareEntities(parameters) {
	const { data, narrative, perspective, filtersList, side, fetchKey } = parameters;
	return (dispatch, getState) => {
		const { defaultEntityType } = getState().projectConfig;
		if (data.error) {
			dispatch({
				type: `${RECEIVE_ENTITIES_ERROR}_${side}`,
				data,
				defaultEntityType,
				narrative,
				perspective,
				filtersList,
				fetchKey,
			});
		} else {
			dispatch({
				type: `${RECEIVE_ENTITIES}${side}`,
				data,
				defaultEntityType,
				narrative,
				perspective,
				filtersList,
				fetchKey,
			});
		}
	};
}

// receive correlation
export function receiveCorrelation(parameters) {
	const { correlation, fetchKey } = parameters;
	return (dispatch, getState) => {
		dispatch({
			type: "receiveCorrelation",
			correlation,
			fetchKey,
			darkUI: getState().projectConfig.darkUI,
		});
	};
}

// clickMapLeft
export function clickMapLeft(data, color, isHighlighted, stateFilterParentId) {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { location } = getState().router;
		const { 
			activeKeywords, 
			activeNarrativeData, 
			mapHighlightId, 
			perspective, 
			filtersList, 
			mapHighlightGeoState 
		} = getState().leftCompare;

		const moeMode = location && location.pathname === "/moe";
		const narType = moeMode ? "leftMOE" : "left";
		const { contentFilteredByDate, currentZoom, filters, entityFilters } = varStore[narType][perspective];

		dispatch(
			clickMapCompare(
				data,
				activeKeywords,
				activeNarrativeData,
				color,
				filtersList,
				currentZoom,
				isHighlighted,
				perspective,
				entityFilters,
				filters,
				reactivateFilters(perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters, filters),
				contentFilteredByDate,
				mapHighlightGeoState,
				mapHighlightId,
				"Left",
				stateFilterParentId
			)
		);
	};
}

// clickMapRight
export function clickMapRight(data, color, isHighlighted, stateFilterParentId) {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { location } = getState().router;
		const { 
			activeKeywords, 
			activeNarrativeData, 
			mapHighlightId, 
			perspective, 
			filtersList, 
			mapHighlightGeoState 
		} = getState().rightCompare;

		const moeMode = location && location.pathname === "/moe";
		const narType = moeMode ? "rightMOE" : "right";
		const { contentFilteredByDate, currentZoom, filters, entityFilters } = varStore[narType][perspective];

		dispatch(
			clickMapCompare(
				data,
				activeKeywords,
				activeNarrativeData,
				color,
				filtersList,
				currentZoom,
				isHighlighted,
				perspective,
				entityFilters,
				filters,
				reactivateFilters(perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters, filters),
				contentFilteredByDate,
				mapHighlightGeoState,
				mapHighlightId,
				"Right",
				stateFilterParentId
			)
		);
	};
}

// clickMapCompare
export function clickMapCompare(
	data,
	activeKeywords,
	activeNarrativeData,
	color,
	currentFiltersList,
	currentZoom,
	isHighlighted,
	perspective,
	entityFilters,
	filtersList,
	filters,
	contentFilteredByDate,
	mapHighlightGeoState,
	mapHighlightId,
	side,
	stateFilterParentId
) {
	return (dispatch, getState) => {
		const { location } = getState().router;
		const eventMode = location && location.pathname === "/events";

		// Filter enabled Map
		if (stateFilterParentId) {
			// Build new geo state filters
			const { mapLookup } = getState().projectConfig;
			const filterObject = convertMapCodeToEntityFilter({ 
				stateObject: data, 
				parent: stateFilterParentId, 
				mapLookup,
				active: true, 
			});
			const newFilters = addOrRemove(currentFiltersList, filterObject, "id");

			// Process the updated filters
			dispatch(
				updateDataCompare({
					side,
					narrative: activeNarrativeData,
					perspective,
					currentZoom,
					activeFilters: newFilters,
					entityFilters, 
					keywords: activeKeywords,
					mapHighlightId,
					contentFilteredByDate,
					eventMode
				})
			);
		}


		// Non-Filter enabled map
		else {
			let mapClickFiltersList = [];
			let countyAlreadyHighlighted;

			// Handle map change UI and set filters by location
			if (isHighlighted) {
				// if a state is highlighted
				countyAlreadyHighlighted =
					side === "Left"
						? getState().leftCompare.mapCountyHighlightId === data.geoState
						: getState().rightCompare.mapCountyHighlightId === data.geoState;

				if (countyAlreadyHighlighted) {
					dispatch({ type: `highlightCountyOff${side}`, setMapToStateLevel: true });
					mapClickFiltersList = isolateStateFilter(filters, mapHighlightGeoState);
				} else {
					// highlight map
					dispatch({ type: `highlightCounty${side}`, data, color });
					// Deactivate location filters, except for the current state. Keeps other non-location filters
					mapClickFiltersList = isolateStateFilter(filters, data);
				}
			} else {
				// set state filters (pass current state only)
				mapClickFiltersList = isolateStateFilter(filters, data);
				dispatch({ type: `highlightMap${side}`, data, color, currentZoom });
			}

			// same parameters if it's a MOE or not
			const params = {
				side,
				narrative: activeNarrativeData,
				perspective,
				currentZoom,
				activeFilters: mapClickFiltersList,
				entityFilters,
				keywords: activeKeywords,
				mapHighlightId: countyAlreadyHighlighted ? mapHighlightId : data.geoState,
				contentFilteredByDate,
				eventMode,
			};
			if (activeNarrativeData.parent === "MOE" || activeNarrativeData.parent === "moe") {
				dispatch(updateDataMoe(params));
			} else {
				// TODO: dispatch an event correlation here, if a project that supports map clicks supports events
				dispatch(updateDataCompare(params));
			}
		};
	}
}

// clear map
export function clearMapLeft() {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { location } = getState().router;
		const { activeNarrativeData, perspective, filtersList, entityFilters } = getState().leftCompare;

		const moeMode = location && location.pathname === "/moe";
		const narType = moeMode ? "leftMOE" : "left";
		const { contentFilteredByDate, currentZoom } = varStore[narType][perspective];

		dispatch({ type: "highlightCountyOffLeft" });
		dispatch(
			clearMapCompare(
				activeNarrativeData,
				perspective,
				currentZoom,
				removeLocationFilters(filtersList),
				entityFilters,
				contentFilteredByDate,
				"Left"
			)
		);
	};
}
export function clearMapRight() {
	return (dispatch, getState) => {
		const { varStore } = getState().storage;
		const { location } = getState().router;
		const { activeNarrativeData, perspective, filtersList, entityFilters } = getState().rightCompare;

		const moeMode = location && location.pathname === "/moe";
		const narType = moeMode ? "rightMOE" : "right";
		const { contentFilteredByDate, currentZoom } = varStore[narType][perspective];

		dispatch({ type: "highlightCountyOffRight" });
		dispatch(
			clearMapCompare(
				activeNarrativeData,
				perspective,
				currentZoom,
				removeLocationFilters(filtersList),
				entityFilters,
				contentFilteredByDate,
				"Right"
			)
		);
	};
}
export function clearMapCompare(narrative, perspective, currentZoom, filtersList, entityFilters, contentFilteredByDate, side) {
	return (dispatch, getState) => {
		const { location } = getState().router;
		const { activeKeywords } = side === "Left" ? getState().leftCompare : getState().rightCompare;

		const eventMode = location && location.pathname === "/events";

		const params = {
			side,
			narrative,
			perspective,
			currentZoom,
			activeFilters: filtersList,
			entityFilters,
			keywords: activeKeywords,
			mapHighlightId: false,
			contentFilteredByDate,
			eventMode,
		};
		dispatch({ type: `clearMapHighlight${side}` });
		if (narrative.parent === "MOE" || narrative.parent === "moe") {
			dispatch(updateDataMoe(params));
		} else {
			dispatch(updateDataCompare(params));
		}
	};
}

export const toggleDuplicatesLeft = () => {
	return (dispatch, getState) => {
		const { showDuplicates } = getState().leftCompare;
		dispatch(
			updateArticleDataCompare({
				side: "Left",
				showDuplicates: !showDuplicates,
			})
		);
		dispatch({
			type: "toggleDuplicatesLeft",
			showDuplicates: !showDuplicates,
		});
	};
};
export const toggleDuplicatesRight = () => {
	return (dispatch, getState) => {
		const { showDuplicates } = getState().rightCompare;
		dispatch(
			updateArticleDataCompare({
				side: "Right",
				showDuplicates: !showDuplicates,
			})
		);
		dispatch({
			type: "toggleDuplicatesRight",
			showDuplicates: !showDuplicates,
		});
	};
};

export const toggleCombine = () => {
	return (dispatch, getState) => {
		const { combineNarratives } = getState().leftCompare;
		dispatch({
			type: combineNarratives ? "unCombineNarratives" : "combineNarratives",
		});
	};
};

export const fetchEventCorrelationInit = (params) => {
	// console.log("fetchEventCorrelationInit", params);
	const { primary, secondary, eventsToFetch, activeFilters, primaryNotFetching } = params;
	const fetchKey = makeFetchKey(secondary, "Source", activeFilters, {});
	return (dispatch) => {
		dispatch({
			type: "fetchEventCorrelationInit",
			primaryId: primary.id,
			secondaryId: secondary.id,
			groupIds: _.pluck(eventsToFetch, "id"),
			fetchKey,
			primaryNotFetching,
			primary,
		});
		_.each(eventsToFetch, (event) => {
			dispatch(
				fetchTimeseriesCompare({
					narrative: event,
					perspective: "Source",
					filtersList: activeFilters,
					notMOE: true,
					fetchKey,
					parent: secondary.parent,
					correlationOnly: true, // Flag to not add this to the graph
					eventMode: true,
				})
			);
		});
	};
};
